import axios from 'axios'

const API_URL = process.env.API_URL
const TIMEOUT = process.env.TIMEOUT

const axiosInstance = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: TIMEOUT,
  responseType: 'json',
  responseEncoding: 'utf8',
  showMessages: true
})

export default axiosInstance



// WEBPACK FOOTER //
// ./src/store/vue-axios/axios.js